import {TextFieldProps} from '../index';
import {TextField} from '@mui/material';

export default (props: TextFieldProps) => {
  const styles =
    props?.sx && Object.keys(props.sx)?.includes('width')
      ? props.sx
      : {...(props.sx ?? {}), width: '100%'};

  return (
    <TextField
      {...props}
      id="lotus-input"
      // label={props.label ?? props.placeholder}
      variant="outlined"
      // placeholder=""
      sx={{...styles}}
    />
  );
};
